// TimetablePlanner Styles Index
// Export all CSS files for easy importing

// Main styles
import './TimetablePlannerMain.css';
import './TimetablePlannerDemo.css';
import './TimetablePlannerView.css';
import './TimetablePlannerDashboard.css';

// Export helper functions
export * as TimetablePlannerHelpers from '../helpers/TimetablePlannerHelpers.js';

// CSS class names for easy reference
export const CSS_CLASSES = {
  // Main page classes
  TIMETABLE_PLANNER_PAGE: 'timetable-planner-page',
  TIMETABLE_PLANNER_HEADER: 'timetable-planner-header',
  TIMETABLE_PLANNER_CONTENT: 'timetable-content',
  
  // Module classes
  MODULE_CARD: 'module-card',
  MODULE_HEADER: 'module-header',
  MODULE_NAME: 'module-name',
  MODULE_DESCRIPTION: 'module-description',
  MODULE_STATUS: 'module-status',
  
  // Workflow classes
  WORKFLOW_PROGRESS: 'workflow-progress',
  WORKFLOW_STEP: 'workflow-step',
  STEP_CIRCLE: 'step-circle',
  STEP_TITLE: 'step-title',
  STEP_DESCRIPTION: 'step-description',
  
  // Status classes
  STATUS_COMPLETED: 'completed',
  STATUS_IN_PROGRESS: 'in-progress',
  STATUS_PENDING: 'pending',
  
  // Action classes
  ACTION_BTN: 'action-btn',
  PRIMARY_BTN: 'primary-btn',
  BACK_BTN: 'back-btn',
  
  // Module navigation classes
  MODULE_NAV_CONTAINER: 'module-nav-container',
  MODULE_NAV_BTN: 'module-nav-btn',
  MODULE_NAV_ICON: 'module-nav-icon',
  MODULE_NAV_TEXT: 'module-nav-text',
  MODULE_NAV_ENGLISH: 'module-nav-english',
  
  // Rooms Details classes
  ROOMS_DETAILS_CONTAINER: 'rooms-details-container',
  ROOMS_HEADER: 'rooms-header',
  ROOMS_CONTENT: 'rooms-content',
  ROOMS_LEFT_PANEL: 'rooms-left-panel',
  ROOMS_RIGHT_PANEL: 'rooms-right-panel',
  DATA_LIST_CONTAINER: 'data-list-container',
  DATA_LIST: 'data-list',
  DATA_ITEM: 'data-item',
  SELECTED_SECTION: 'selected-section',
  ROOM_SECTION: 'room-section',
  HOME_ROOM_SECTION: 'home-room-section',
  NAV_BUTTONS: 'nav-buttons',
  ACTION_BUTTONS: 'action-buttons',
  
  // Double Lessons Details classes
  DOUBLE_LESSONS_CONTAINER: 'double-lessons-container',
  DOUBLE_LESSONS_HEADER: 'double-lessons-header',
  DOUBLE_LESSONS_CONTENT: 'double-lessons-content',
  DOUBLE_LESSONS_LEFT_PANEL: 'double-lessons-left-panel',
  DOUBLE_LESSONS_MIDDLE_PANEL: 'double-lessons-middle-panel',
  DOUBLE_LESSONS_RIGHT_PANEL: 'double-lessons-right-panel',
  DOUBLE_COUNT_SECTION: 'double-count-section',
  DOUBLE_COUNT_CONTROLS: 'double-count-controls',
  DOUBLE_COUNT_INPUT: 'double-count-input',
  DOUBLE_COUNT_DROPDOWN: 'double-count-dropdown',
  DOUBLE_COUNT_SELECT: 'double-count-select',
  COUNT_BTN: 'count-btn',
  SELECTED_LIST: 'selected-list',
  SELECTED_ITEM: 'selected-item',
  PRINT_SECTION: 'print-section',
  PRINT_BTN: 'print-btn',
  
  // Card classes
  OVERVIEW_CARD: 'overview-card',
  DETAIL_CARD: 'detail-card',
  STAT_CARD: 'stat-card',
  
  // Grid classes
  MODULES_GRID: 'modules-grid',
  OVERVIEW_GRID: 'overview-grid',
  DETAIL_GRID: 'detail-grid',
  
  // Loading and error classes
  LOADING_SPINNER: 'loading-spinner',
  TIMETABLE_PLANNER_ERROR: 'timetable-planner-error',
  NO_DATA: 'no-data'
};

// Color themes for modules
export const MODULE_THEMES = {
  PREPARATION: { primary: '#10b981', secondary: '#059669' },
  PLANNER: { primary: '#f59e0b', secondary: '#d97706' },
  SETTINGS: { primary: '#8b5cf6', secondary: '#7c3aed' },
  PLANNING: { primary: '#06b6d4', secondary: '#0891b2' },
  GENERATION: { primary: '#ec4899', secondary: '#db2777' },
  DATASET: { primary: '#84cc16', secondary: '#65a30d' }
};

// Status colors
export const STATUS_COLORS = {
  COMPLETED: '#27ae60',
  IN_PROGRESS: '#f39c12',
  PENDING: '#95a5a6',
  ERROR: '#e74c3c',
  WARNING: '#f39c12',
  INFO: '#3498db'
};

// Responsive breakpoints
export const BREAKPOINTS = {
  MOBILE: '480px',
  TABLET: '768px',
  DESKTOP: '1024px',
  LARGE: '1200px'
};
